module.exports = __webpack_public_path__ + "img/20-3.e66b6530.png";